/**
 * Toast global não-bloqueante - substitui QUALQUER `alert()` nativo (regra do
 * projeto: nenhum diálogo do navegador). Função pura de DOM pra poder ser
 * chamada de utilitários fora da árvore React (ex.: exportConversation).
 */
let container: HTMLDivElement | null = null;

function ensureContainer(): HTMLDivElement {
  if (container && document.body.contains(container)) return container;
  container = document.createElement("div");
  container.className = "app-toasts";
  container.setAttribute("role", "status");
  container.setAttribute("aria-live", "polite");
  document.body.appendChild(container);
  return container;
}

export function showToast(message: string, kind: "info" | "error" | "success" = "info"): void {
  const root = ensureContainer();
  const el = document.createElement("div");
  el.className = `app-toast ${kind}`;
  el.textContent = message;
  root.appendChild(el);
  // entrada/saída via classe (transição no CSS); remove após 5s ou no clique
  requestAnimationFrame(() => el.classList.add("show"));
  const close = () => {
    el.classList.remove("show");
    setTimeout(() => el.remove(), 250);
  };
  el.addEventListener("click", close);
  setTimeout(close, 5000);
}
